<template>
  <div v-click-outside="outsideClosePopup" class="dropdown">
    <button
      :id="id"
      class="btn btn-dropdown-actions dropdown-toggle float-right pt-1 custom-dropdown-block dropdown-rounded-button"
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      @click="closePopup"
    >
      <span class="dropdown-rounded-title">
        {{ model == null ? placeholder : model.name }}
      </span>
      <div class="rounded-chevron">
        <em
          class="icon-chevron__color"
          :class="{
            'fas fa-chevron-down': !expanded,
            'fas fa-chevron-up': expanded,
          }"
        />
      </div>
    </button>
    <div
      class="dropdown-menu dropdown-menu-right dropdown-rounded-container"
      :aria-labelledby="id"
    >
      <div
        v-for="item in options"
        :key="item.id"
        class="dropdown-rounded-item"
        @click="onSelectItem(item)"
      >
        <span>{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import ClickOutside from 'vue-click-outside';
export default {
  name: 'CustomDropDownRounded',
  directives: {
    ClickOutside,
  },
  props: {
    id: {
      type: String,
      default: 'dropdownMenuButtonRounded'
    },
    value: {
      type: Object,
      default: null,
    },
    placeholder: {
      type: String,
      default: () => '',
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      expanded: false,
      selected: '',
      model: null,
    };
  },
  watch: {
    model: {
      deep: true,
      immediate: true,
      handler(value) {
        this.$emit('input', value);
      },
    },
    value: {
      deep: true,
      immediate: true,
      handler(value) {
        this.model = value;
      },
    },
  },
  methods: {
    closePopup() {
      this.expanded = !this.expanded;
    },
    //This methods avoid the element have issues with expanded
    outsideClosePopup() {
      if (this.expanded) this.closePopup();
    },
    onSelectItem(item) {
      this.model = item;
    },
  },
};
</script>

<style scoped>
.dropdown-rounded-button {
  padding-left: 20px;
  border-radius: 22px;
  border: none;
  height: 2.7rem;
  width: auto;
  background: #a9b7b0;
}
.dropdown-rounded-button::after {
  display: none;
}
.dropdown-rounded-title {
  color: #fff;
  font-size: 16px;
  margin-right: 20px;
}
.dropdown-rounded-container {
  margin-bottom: -10px;
}
.dropdown-rounded-item {
  cursor: pointer;
  margin: 10px 10px 10px 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e2e2e2;
}
.rounded-chevron {
  display: inline-block;
  width: 30px;
  height: 30px;
  background: #3f5b61;
  color: #fff;
  padding: 5px;
  border-radius: 50px;
  line-height: 1.4;
  margin-right: 1px;
}
.rounded-chevron i {
  margin-bottom: -10px;
}
.icon-chevron__color {
  color: #fff;
}
</style>
